import script from "./DeleteSipDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteSipDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteSipDialog.vue?vue&type=style&index=0&id=31389720&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31389720"]])

export default __exports__